import { defineMessages } from 'react-intl';

export default defineMessages({
  absenceBegin: {
    id: 'app.components.AbsenceForm.absenceBegin',
    defaultMessage: 'Begin of absence',
  },
  absenceEnd: {
    id: 'app.components.AbsenceForm.absenceEnd',
    defaultMessage: 'End of absence (inclusive)',
  },
  endMustNotBeforeBegin: {
    id: 'app.components.AbsenceForm.endMustNotBeforeBegin',
    defaultMessage: 'The end of the absence must not be before its beginning.',
  },
  startMustNotBeInThePast: {
    id: 'app.components.AbsenceForm.startMustNotBeInThePast',
    defaultMessage: 'The begin of the absence must not be in the past.',
  },
  saveAbsence: {
    id: 'app.components.AbsenceForm.saveAbsence',
    defaultMessage: 'Save',
  },
});
